import { createSelector } from '@ngrx/store';
import { AppState } from '../lemans-app.model';
import { TrialsState } from './trials.model';

const stateSelector = (state: AppState): TrialsState => state.trials;

const selectTrialsState = createSelector(stateSelector, (trialState: TrialsState) => trialState);

export const selectTrialReservation = createSelector(selectTrialsState, (state: TrialsState) => state.reservation);

export const selectTrialBundles = createSelector(selectTrialsState, (state: TrialsState) => state.bundles);
export const selectRefreshTrialsGrid = createSelector(selectTrialsState, (state: TrialsState) => state.refreshGrid);
